import React from "react";
import PageLayout from "../../../components/Layout/PageLayout";
import Hyperlink from "../../../components/elements/HyperLink";

const TermsOfService: React.FC = () => {

 const now = new Date();
  const options = { 
    year: 'numeric', 
    month: 'long', 
    // day: 'numeric' 
  } as const; 

  const formattedDate = now.toLocaleDateString('en-US', options);

  return (
    <PageLayout>
      <div className="w-full">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600/0 to-indigo-700/0 pt-6 text-center">
          <h1 className="text-[20px] md:text-[35px] mb-2">Terms of Service</h1>
          <div className="flex justify-center">
            <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-medium">
              Last Updated: {formattedDate}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="py-5">
          <div className="prose prose-lg max-w-none prose-blue prose-headings:font-medium prose-p:text-gray-700 prose-li:text-gray-700">
            {/* Introduction */}
            <div className="mb-5 p-5 bg-blue-50 rounded-lg border border-primary/10">
              <p className="text-gray-700 mb-4">
                Please read these Terms of Service ("Terms") carefully before
                using the{" "}
                <a href="/" className="font-medium text-primary">
                  https://25thairecruiter.com
                </a>{" "}
                website (the "Website") or the AI Recruiter Application (the
                "Services") operated by 25th & Staffing ("us", "we", or "our").
              </p>
              <p className="text-gray-700 mb-4">
                Your access to and use of the Website and Services is
                conditioned on your acceptance of and compliance with these
                Terms. These Terms apply to all visitors, users, and others who
                access or use the Website or Services.
              </p>
              <p className="text-gray-700 font-medium">
                By accessing or using the Website or Services, you agree to be
                bound by these Terms. If you disagree with any part of the
                terms, then you may not access the Website or Services.
              </p>
            </div>

            {/* Section 1: Subscription Services */}
            <section className="mb-5">
              <h2 className="text-xl font-medium text-gray-900 mb-2 flex items-center">
                <span className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center mr-2 flex-shrink-0">
                  1
                </span>
                Subscription Services
              </h2>
              <p className="text-gray-700 ml-3 md:ml-11">
                For paying customers, the use of the AI Recruiter Application is
                governed by these Terms, in addition to a signed Master Services
                Agreement (MSA), a Scope of Work (SOW), and an Order Form. In
                the event of any conflict between these Terms and the MSA, the
                terms of the MSA shall prevail.
              </p>
            </section>

            {/* Section 2: Accounts */}
            <section className="mb-5">
              <h2 className="text-xl font-medium text-gray-900 mb-2 flex items-center">
                <span className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center mr-2 flex-shrink-0">
                  2
                </span>
                Accounts
              </h2>
              <p className="text-gray-700 ml-3 md:ml-11 mb-4">
                When you create an account with us, you must provide information
                that is accurate, complete, and current at all times. Failure to
                do so constitutes a breach of the Terms, which may result in
                immediate termination of your account on our Service.
              </p>
              <p className="text-gray-700 ml-3 md:ml-11 mb-4">
                You are responsible for safeguarding the password that you use
                to access the Service and for any activities or actions under
                your password, whether your password is with our Service or a
                third-party service.
              </p>
              <p className="text-gray-700 ml-3 md:ml-11">
                You agree not to disclose your password to any third party. You
                must notify us immediately upon becoming aware of any breach of
                security or unauthorized use of your account.
              </p>
            </section>

            {/* Section 3: Intellectual Property */}
            <section className="mb-5">
              <h2 className="text-xl font-medium text-gray-900 mb-2 flex items-center">
                <span className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center mr-2 flex-shrink-0">
                  3
                </span>
                Intellectual Property
              </h2>
              <p className="text-gray-700 ml-3 md:ml-11">
                The Website and Services and their original content excluding
                (Customer Data), features, and functionality are and will remain
                the exclusive property of 25th & Staffing and its licensors. The
                Services are protected by copyright, trademark, and other laws
                of both the Federal Republic of Nigeria and foreign countries.
              </p>
            </section>

            {/* Section 4: Links To Other Web Sites */}
            <section className="mb-5">
              <h2 className="text-xl font-medium text-gray-900 mb-2 flex items-center">
                <span className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center mr-2 flex-shrink-0">
                  4
                </span>
                Links To Other Web Sites
              </h2>
              <p className="text-gray-700 ml-3 md:ml-11 mb-4">
                Our Service may contain links to third-party web sites or
                services that are not owned or controlled by 25th & Staffing.
              </p>
              <p className="text-gray-700 ml-3 md:ml-11">
                25th & Staffing has no control over, and assumes no
                responsibility for, the content, privacy policies, or practices
                of any third-party web sites or services. You further
                acknowledge and agree that 25th & Staffing shall not be
                responsible or liable, directly or indirectly, for any damage or
                loss caused or alleged to be caused by or in connection with use
                of or reliance on any such content, goods or services available
                on or through any such web sites or services.
              </p>
            </section>

            {/* Section 5: Termination */}
            <section className="mb-5">
              <h2 className="text-xl font-medium text-gray-900 mb-2 flex items-center">
                <span className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center mr-2 flex-shrink-0">
                  5
                </span>
                Termination
              </h2>
              <p className="text-gray-700 ml-3 md:ml-11 mb-4">
                We may terminate or suspend access to our Website or Service
                immediately, without prior notice or liability, for any reason
                whatsoever, including without limitation if you breach the
                Terms.
              </p>
              <p className="text-gray-700 ml-3 md:ml-11">
                For paying customers, termination of Services is governed by the
                executed Master Services Agreement (MSA).
              </p>
            </section>

            {/* Section 6: Disclaimer */}
            <section className="mb-5">
              <h2 className="text-xl font-medium text-gray-900 mb-2 flex items-center">
                <span className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center mr-2 flex-shrink-0">
                  6
                </span>
                Disclaimer
              </h2>
              <p className="text-gray-700 ml-3 md:ml-11">
                Your use of the Website and Services is at your sole risk. The
                Website and Services are provided on an "AS IS" and "AS
                AVAILABLE" basis. The Website and Services are provided without
                warranties of any kind, whether express or implied, including,
                but not limited to, implied warranties of merchantability,
                fitness for a particular purpose, non-infringement, or course of
                performance.
              </p>
            </section>

            {/* Section 7: Limitation of Liability */}
            <section className="mb-5">
              <h2 className="text-xl font-medium text-gray-900 mb-2 flex items-center">
                <span className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center mr-2 flex-shrink-0">
                  7
                </span>
                Limitation of Liability
              </h2>
              <p className="text-gray-700 ml-3 md:ml-11">
                In no event shall 25th & Staffing, nor its directors, employees,
                partners, agents, suppliers, or affiliates, be liable for any
                indirect, incidental, special, consequential or punitive
                damages, including without limitation, loss of profits, data,
                use, goodwill, or other intangible losses, resulting from (i)
                your access to or use of or inability to access or use the
                Service; (ii) any conduct or content of any third party on the
                Service; (iii) any content obtained from the Service; and (iv)
                unauthorized access, use or alteration of your transmissions or
                content, whether based on warranty, contract, tort (including
                negligence) or any other legal theory, whether or not we have
                been informed of the possibility of such damage.
              </p>
            </section>

            {/* Section 8: Governing Law */}
            <section className="mb-5">
              <h2 className="text-xl font-medium text-gray-900 mb-2 flex items-center">
                <span className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center mr-2 flex-shrink-0">
                  8
                </span>
                Governing Law
              </h2>
              <p className="text-gray-700 ml-3 md:ml-11">
                These Terms shall be governed and construed in accordance with
                the laws of the Federal Republic of Nigeria, without regard to
                its conflict of law provisions.
              </p>
            </section>

            {/* Section 9: Changes */}
            <section className="mb-5">
              <h2 className="text-xl font-medium text-gray-900 mb-2 flex items-center">
                <span className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center mr-2 flex-shrink-0">
                  9
                </span>
                Changes
              </h2>
              <p className="text-gray-700 ml-3 md:ml-11">
                We reserve the right, at our sole discretion, to modify or
                replace these Terms at any time. If a revision is material, we
                will try to provide at least 30 days' notice prior to any new
                terms taking effect.
              </p>
              <p className="text-gray-700 ml-3 md:ml-11 mt-4">
                By continuing to access or use our Service after those revisions
                become effective, you agree to be bound by the revised terms.
              </p>
            </section>

            {/* Section 10: Contact Us */}
            <section>
              <h2 className="text-xl font-medium text-gray-900 mb-2 flex items-center">
                <span className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center mr-2 flex-shrink-0">
                  10
                </span>
                Contact Us
              </h2>
              <p className="text-gray-700 ml-3 md:ml-11">
                If you have any questions about these Terms, please contact us
                at:{" "}
                <Hyperlink
                  href="mailto:privacy@25thmail.com"
                  className="text-primary"
                >
                  privacy@25thmail.com
                </Hyperlink>
              </p>
            </section>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default TermsOfService;
